module.exports = __webpack_public_path__ + "img/link-dist.4e360838.svg";